import React from "react";
import "./BeerSlot.scss";
import { Beer } from "../../data/types";

interface BeerSlotProps {
  beer: Beer | null;
  index: number;
  handleSelect?: (beer: Beer) => void;
  onClick?: (index: number) => void;
  unavailable?: boolean;
}

const BeerSlot: React.FC<BeerSlotProps> = ({
  beer,
  index,
  handleSelect,
  onClick,
  unavailable = false,
}) => {
  const handleClick = () => {
    if (unavailable) return;
    if (beer && handleSelect) {
      handleSelect(beer);
    } else if (onClick) {
      onClick(index - 1);
    }
  };

  return (
    <div
      className={`beerslot${unavailable ? " beerslot--unavailable" : ""}`}
      onClick={handleClick}
    >
      <div className="img-wrapper">
        {beer && <img src={beer?.image} alt="" />}
      </div>
      <div className="beerslot__text-div">
        <h3>{beer?.name}</h3>

        <div className="beerslot__beer-text-div">
          {unavailable ? (
            <p className="beerslot__unavailable-label">Ej i lager</p>
          ) : (
            <>
              <p>{beer ? beer?.abv + "%" : ""}</p>
              <p>{beer?.type}</p>
            </>
          )}
        </div>
      </div>
      <p className={`beerslot__number${index === 0 ? "--hide" : ""}`}>
        {index}
      </p>
    </div>
  );
};

export default BeerSlot;
